import { PageLoading } from 'components/loading'
import { useAtividadeColetivaVisualizarSaudeQuery } from 'graphql/hooks.generated'
import { Redirect, useParams } from 'react-router'

import { AtividadeColetivaVisualizarSaudeView } from './AtividadeColetivaVisualizarSaudeView'

interface AtividadeColetivaSaudeViewParams {
  atividadeColetivaId: ID
}

export function AtividadeColetivaSaudeView() {
  const { atividadeColetivaId } = useParams<AtividadeColetivaSaudeViewParams>()

  const {
    data: { atividadeColetiva },
    loading,
  } = useAtividadeColetivaVisualizarSaudeQuery({
    variables: { atividadeColetivaId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!atividadeColetiva) {
    return <Redirect to='/404' />
  } else {
    return <AtividadeColetivaVisualizarSaudeView atividadeColetiva={atividadeColetiva} isFonteDadosPec={true} />
  }
}
